<mat-card class="exchange-card cardWithShadow">
    <div class="exchange-card__content-wrapper">
        <!-- Loading overlay -->
        <div class="exchange-card__loading-overlay" *ngIf="isLoading">
            <mat-spinner [diameter]="40"></mat-spinner>
            <p class="exchange-card__loading-text">Cargando información de: {{ dateCtrl.value | date: 'dd/MM/yyyy' }}...</p>
        </div>

        <div class="exchange-card__header">
            <div class="exchange-card__title-block">
                <h3 class="exchange-card__title">{{ data.title || 'Tipo de Cambio' }}</h3>
                <span class="exchange-card__badge" *ngIf="!isEmpty">Última actualización: {{ data.lastUpdatedLabel }}</span>
            </div>

            <mat-form-field appearance="outline" class="exchange-card__date-field">
                <!-- <mat-label></mat-label> -->
                <input matInput placeholder="dd/MM/yyyy" [matDatepicker]="picker" [formControl]="dateCtrl"
                    (dateChange)="onDateChange($event)" />
                <mat-datepicker-toggle matSuffix [for]="picker">
                    <i-tabler matDatepickerToggleIcon name="calendar-event" class="exchange-card__date-icon"></i-tabler>
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="exchange-card__grid">
            <!-- Empty state -->
            <div class="exchange-card__empty-state" *ngIf="isEmpty">
                <i-tabler name="calendar-x" class="exchange-card__empty-icon" [attr.size]="20"></i-tabler>
                <h4 class="exchange-card__empty-title">No se encontraron resultados</h4>
                <p class="exchange-card__empty-message">
                    No se registró un tipo de cambio para esta fecha.<br />
                    Por favor inténtalo nuevamente.
                </p>
            </div>

            <!-- Data rows -->
            <ng-container *ngIf="!isEmpty">
                <div class="exchange-card__row">
                    <span class="exchange-card__label exchange-card__label--left">Compra</span>
                    <span class="exchange-card__value">S/ {{ data.buy | number: '1.5-5': 'en-US' }}</span>
                    <span class="exchange-card__label exchange-card__label--right">Cierre Compra</span>
                    <span class="exchange-card__secondary">{{ data.closeBuy | number: '1.5-5': 'en-US' }}</span>
                </div>

                <div class="exchange-card__row">
                    <span class="exchange-card__label exchange-card__label--left">Venta</span>
                    <span class="exchange-card__value">S/ {{ data.sell | number: '1.5-5': 'en-US' }}</span>
                    <span class="exchange-card__label exchange-card__label--right">Cierre Venta</span>
                    <span class="exchange-card__secondary">{{ data.closeSell | number: '1.5-5': 'en-US' }}</span>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="exchange-card__actions">
        <button mat-button color="primary" class="exchange-card__btn exchange-card__btn--muted"
            (click)="onMonthlyRate()">
            Tipo de cambio mensual
        </button>
        <button mat-stroked-button color="primary" class="exchange-card__btn exchange-card__btn--accent"
            (click)="onManage()">
            Gestionar tipo de cambio
        </button>
    </div>
</mat-card>